import React from "react";
import "./CreateAndSaveButton.css";
import { Button } from "react-bootstrap";

const CreateAndSaveButton = ({ createTest ,children }) => {
  return (
    <Button className="frame" onClick={createTest}>
      <div className="text-wrapper">{children}</div>
    </Button>
  );
};

export default CreateAndSaveButton;
